<template>
  <ok-modal
    :value="value"
    size="lg"
    dialog-class="tables-modal"
    :title="$t('reply.enable-by-id-title')"
    @change="handleClose"
  >
    <validation-observer ref="form">
      <error-alert
        v-if="error"
        :error="error"
      />
      <b-row class="justify-content-center">
        <b-col
          md="8"
          sm="12"
        >
          <ok-text-input
            v-model="form.post_id"
            :label="$t('reply.write_post_id')"
            :placeholder="$t('reply.write_post_id')"
          />
        </b-col>
        <b-col
          md="8"
          sm="12"
        >
          <p class="text-center text-muted my-1">
            {{ $t('general.or') }}
          </p>
        </b-col>
        <b-col
          md="8"
          sm="12"
        >
          <ok-text-input
            v-model="form.post_url"
            :label="$t('reply.post_url')"
            :placeholder="$t('reply.write_post_url')"
          />
          <p class="text-muted small mb-0">
            {{ $t('reply.post_url_hint') }}
          </p>
        </b-col>
        <b-col
          v-if="checkedPost"
          md="8"
          sm="12"
          class="mt-2"
        >
          <b-card>
            <b-row>
              <b-col
                cols="4"
                md="3"
              >
                <b-img
                  :src="checkedPost.picture"
                  style="max-height: 80px;width: 100%"
                  alt="post"
                  rounded
                  thumbnail
                  fluid
                />
              </b-col>
              <b-col
                cols="8"
                md="9"
              >
                <p class="mb-1">
                  {{ checkedPost.message }}
                </p>
                <a
                  v-if="checkedPost.link"
                  :href="checkedPost.link"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="small"
                >
                  {{ $t('reply.open-post') }}
                </a>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </validation-observer>
    <template #actions>
      <div class="d-flex justify-content-end align-items-center">
        <b-button
          v-if="!checkedPost"
          variant="outline-dark"
          :disabled="checking"
          @click="checkPost"
        >
          <b-spinner
            v-if="checking"
            small
            class="ml-1"
          />
          {{ $t('reply.check_post_exist') }}
        </b-button>
        <b-button
          v-else
          :variant="checkedPost.enabled ? 'warning' : 'success'"
          @click="enableAutoReply"
        >
          {{ $t(`reply.${checkedPost.enabled ? 'edit' : 'enable'}`) }}
        </b-button>
        <b-button
          variant="dark"
          class="ml-1"
          :disabled="checking"
          @click="handleClose"
        >
          {{ $t('forms.cancel') }}
        </b-button>
      </div>
    </template>
  </ok-modal>
</template>

<script>
import {
  BButton, BRow, BCol, BSpinner, BCard, BImg,
} from 'bootstrap-vue'
import OkModal from '@/@bya3/components/modals/OkModal'
import OkTextInput from '@/@bya3/components/inputs/OkTextInput'
import ErrorAlert from '@/@bya3/components/alerts/ErrorAlert'
import { ValidationObserver } from 'vee-validate'
import PageApi from '@/api/page'
import { mapGetters } from 'vuex'

export default {
  name: 'EnableByIdModal',
  components: {
    ErrorAlert,
    OkTextInput,
    ValidationObserver,
    OkModal,
    BButton,
    BRow,
    BCol,
    BSpinner,
    BCard,
    BImg,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      error: null,
      checking: false,
      checkedPost: null,
      form: {
        post_id: '',
        post_url: '',
      },
    }
  },
  computed: {
    ...mapGetters({
      currentPageId: 'pages/currentPageId',
    }),
  },
  watch: {
    value(open) {
      if (!open) {
        this.resetForm()
      }
    },
  },
  methods: {
    resetForm() {
      this.error = null
      this.checking = false
      this.checkedPost = null
      this.form = { post_id: '', post_url: '' }
    },
    handleClose() {
      this.$emit('input', false)
    },
    async checkPost() {
      this.error = null
      this.checkedPost = null
      const valid = await this.$refs.form.validate()
      if (!valid) {
        this.error = this.$tc('errors.field-invalid', 2)
        return
      }
      if (!this.form.post_id?.trim() && !this.form.post_url?.trim()) {
        this.error = this.$t('reply.provide_correct_post_id')
        return
      }
      this.checking = true
      try {
        const payload = {}
        if (this.form.post_id?.trim()) payload.post_id = this.form.post_id.trim()
        if (this.form.post_url?.trim()) payload.post_url = this.form.post_url.trim()
        const res = await PageApi.checkPost(this.currentPageId, payload)
        if (res.error === 0) {
          this.checkedPost = res.post
        } else {
          this.error = res.message ?? this.$t('reply.provide_correct_post_id')
        }
      } catch (e) {
        this.error = e
      } finally {
        this.checking = false
      }
    },
    enableAutoReply() {
      if (!this.checkedPost) return
      this.$store.commit('reply/SET_FORM', {
        post_description: this.checkedPost?.full_message ?? '',
        post_thumb: this.checkedPost.picture,
      })
      const routeName = this.checkedPost.enabled ? 'owner:reply-edit' : 'owner:reply'
      this.$router.push({ name: routeName, params: { id: this.checkedPost.id } })
      this.handleClose()
    },
  },
}
</script>
